import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { FaCheck, FaTimes } from "react-icons/fa";
import "./Tarifs.css";

const plans = [
  {
    name: "Starter",
    tag: "Site vitrine",
    price: "150 000",
    delay: "7 a 10 jours",
    features: [
      "Jusqu'a 5 pages (Accueil, Services, A propos, Contact...)",
      "Design responsive — parfait sur telephone",
      "Chargement rapide sur 3G",
      "Optimisation SEO basique",
      "Formulaire de contact fonctionnel",
      "Integration WhatsApp",
      "Hebergement et mise en ligne inclus",
    ],
    cta: "Demarrer",
    highlight: false,
  },
  {
    name: "Business",
    tag: "E-commerce",
    price: "300 000",
    delay: "2 a 4 semaines",
    features: [
      "Boutique en ligne sur mesure",
      "Catalogue produits avec photos et descriptions",
      "Paiement Orange Money et Wave integre",
      "Gestion des commandes et des stocks",
      "Interface admin pour gerer vos produits",
      "Espace client (historique commandes)",
      "Design responsive mobile-first",
      "Formation a l'utilisation incluse",
    ],
    cta: "Demarrer",
    highlight: true,
  },
  {
    name: "Pro",
    tag: "Application web ou mobile",
    price: "500 000",
    delay: "3 a 8 semaines",
    features: [
      "Application web ou mobile sur mesure (React / React Native)",
      "iOS + Android depuis un seul code source",
      "Systeme de connexion et gestion des utilisateurs",
      "Tableau de bord administrateur",
      "Integration API et services tiers",
      "Notifications push (mobile)",
      "Support technique 3 mois apres livraison",
      "Documentation incluse",
    ],
    cta: "Discutons",
    highlight: false,
  },
];

const comparison = [
  { feature: "Site web responsive", starter: true, business: true, pro: true },
  { feature: "Chargement rapide sur 3G", starter: true, business: true, pro: true },
  { feature: "Formulaire de contact", starter: true, business: true, pro: true },
  { feature: "WhatsApp integre", starter: true, business: true, pro: true },
  { feature: "Optimisation SEO", starter: true, business: true, pro: true },
  { feature: "Boutique en ligne", starter: false, business: true, pro: true },
  { feature: "Paiement Orange Money / Wave", starter: false, business: true, pro: true },
  { feature: "Gestion des stocks & commandes", starter: false, business: true, pro: true },
  { feature: "Interface admin produits", starter: false, business: true, pro: true },
  { feature: "Application mobile (iOS + Android)", starter: false, business: false, pro: true },
  { feature: "Tableau de bord administrateur", starter: false, business: false, pro: true },
  { feature: "Notifications push", starter: false, business: false, pro: true },
  { feature: "Integration API externe", starter: false, business: false, pro: true },
  { feature: "Formation a l'utilisation", starter: true, business: true, pro: true },
  { feature: "Support 3 mois apres livraison", starter: false, business: false, pro: true },
  { feature: "Paiement en tranches", starter: true, business: true, pro: true },
];

function Cell({ value }) {
  return value
    ? <span className="compare-yes"><FaCheck size={13} /></span>
    : <span className="compare-no"><FaTimes size={13} /></span>;
}

export default function Tarifs() {
  return (
    <>
      <Helmet>
        <title>Tarifs — NEXUS SOLUTIONS</title>
        <meta name="description" content="Decouvrez les tarifs de NEXUS SOLUTIONS pour la creation de sites web, applications mobiles et boutiques e-commerce a Abidjan. Devis gratuit." />
      </Helmet>

      <div className="tarifs-page">
        <div className="tarifs-hero">
          <h1>Nos tarifs</h1>
          <p>Des prix adaptes au marche ivoirien, sans compromis sur la qualite. Tous les projets commencent par un devis gratuit.</p>
        </div>

        <div className="tarifs-grid">
          {plans.map((plan) => (
            <div key={plan.name} className={`tarif-card${plan.highlight ? " tarif-card--highlight" : ""}`}>
              {plan.highlight && <div className="tarif-badge">Le plus demande</div>}
              <div className="tarif-tag">{plan.tag}</div>
              <div className="tarif-name">{plan.name}</div>
              <div className="tarif-price">
                a partir de <strong>{plan.price} FCFA</strong>
              </div>
              <div className="tarif-delay">Livraison : {plan.delay}</div>
              <ul className="tarif-features">
                {plan.features.map((f) => (
                  <li key={f}>
                    <FaCheck className="tarif-check" size={13} />
                    {f}
                  </li>
                ))}
              </ul>
              <Link to="/devis" className="tarif-cta">{plan.cta}</Link>
            </div>
          ))}
        </div>

        {/* Tableau comparatif */}
        <div className="compare-section">
          <h2 className="compare-title">Comparatif detaille</h2>
          <div className="compare-table-wrap">
            <table className="compare-table">
              <thead>
                <tr>
                  <th className="compare-feature-col">Fonctionnalite</th>
                  <th>Starter</th>
                  <th className="compare-highlight-col">Business</th>
                  <th>Pro</th>
                </tr>
              </thead>
              <tbody>
                {comparison.map((row) => (
                  <tr key={row.feature}>
                    <td className="compare-feature-name">{row.feature}</td>
                    <td><Cell value={row.starter} /></td>
                    <td className="compare-highlight-col"><Cell value={row.business} /></td>
                    <td><Cell value={row.pro} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="tarifs-custom">
          <h2>Projet sur mesure ?</h2>
          <p>Votre besoin ne rentre pas dans ces formules ? Pas de probleme. On discute de votre projet et on vous propose un devis adapte a votre budget et vos objectifs.</p>
          <div className="tarifs-custom-actions">
            <Link to="/devis" className="tarifs-custom-cta">Obtenir un devis gratuit</Link>
            <a
              href="mailto:contact@nxs-solutions.com"
              className="tarifs-wa-cta"
            >
              Nous ecrire par email
            </a>
          </div>
        </div>

        <div className="tarifs-note">
          <p>
            Les prix indiques sont des points de depart. Le devis final depend du nombre de fonctionnalites, du design souhaite et des integrations specifiques. Paiement possible en plusieurs tranches.
          </p>
        </div>
      </div>
    </>
  );
}
